import { RoleCoreBase } from "./role.core.base"


export class RoleCore extends RoleCoreBase {

}